import { render, staticRenderFns } from "./SideMenuWorkplace.vue?vue&type=template&id=2b1251be"
import script from "./SideMenuWorkplace.vue?vue&type=script&lang=js"
export * from "./SideMenuWorkplace.vue?vue&type=script&lang=js"
import style0 from "./SideMenuWorkplace.vue?vue&type=style&index=0&id=2b1251be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports